import { render, staticRenderFns } from "./UsdtTransactionListItem.vue?vue&type=template&id=6d1af1f0&scoped=true&"
import script from "./UsdtTransactionListItem.vue?vue&type=script&lang=ts&"
export * from "./UsdtTransactionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./UsdtTransactionListItem.vue?vue&type=style&index=0&id=6d1af1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1af1f0",
  null
  
)

export default component.exports